import React from 'react';
import { IJobPaymentError, ITeacher } from 'models';
import { Grid } from '@mui/material';
import { Colors, PrimaryButton, SecondaryButton, Text } from 'library';
import JobTemplateListContent from 'parent-portal/forms/components/pages/SelectTemplatePage/JobTemplateListContent';
import { useUserContext } from 'UserContext';
import { convertPreferredSitterObject } from 'parent-portal/forms/components/pages/ProviderPreferencesPage/preferredWorkersApi';
import { submitOngoingRequest } from 'parent-portal/forms/JobRequestSubmission';
import JobPaymentErrorDisplay from 'parent-portal/forms/components/JobPaymentErrorDisplay';

export default function InviteWorkersToJob({
    selectedWorkers,
    goBack,
    onSubmit,
}: {
    selectedWorkers: ITeacher[];
    goBack: () => void;
    onSubmit: () => void;
}) {
    const [selectedJob, setSelectedJob] = React.useState<number>();
    const [error, setError] = React.useState('');
    const [paymentError, setPaymentError] = React.useState<IJobPaymentError>();
    const { user } = useUserContext();
    const [address, setAddress] = React.useState<number | null>(user?.address[0]?.id || null);
    const [loading, setLoading] = React.useState(false);

    function submit() {
        setError('');
        setPaymentError(undefined);
        if (!selectedJob) return;
        setLoading(true);
        submitOngoingRequest({ preferred_sitters: convertPreferredSitterObject([], [], selectedWorkers) }, selectedJob)
            .then(onSubmit)
            .catch((error) => {
                const errorText = error?.errors?.length ? error.errors.map((x: string) => x).join(' ') : undefined;
                if (errorText) {
                    setError(
                        errorText ||
                            'There was an error inviting the user to this job. Try again or reach out to support',
                    );
                } else if (error?.payment) {
                    setPaymentError(error?.payment);
                } else {
                    setError('There was an error inviting the user to this job. Try again or reach out to support');
                }
            })
            .finally(() => setLoading(false));
    }

    return (
        <>
            <Text variant="h1" textStyle={{ fontSize: 28 }}>
                Invite Teachers to existing job
            </Text>
            <Text variant="body1" bold textStyle={{ marginBottom: 20, marginTop: 20 }}>
                Selected teachers:{' '}
                <Text variant="body1" inline>
                    {selectedWorkers.map((w) => w.name).join(', ')}
                </Text>
            </Text>
            <Grid container flexDirection="column" gap={2} flex={1}>
                <Grid container gap={2} flexDirection="column" flex={1}>
                    <JobTemplateListContent
                        address={address}
                        setAddress={setAddress}
                        emptyText="Sorry, we couldn't find any open jobs for this location."
                        selectedJobId={selectedJob}
                        setSelectedJobId={setSelectedJob}
                        openJobsOnly
                    />
                </Grid>
                <Text textStyle={{ color: Colors.error, marginTop: 10 }} variant="body2">
                    {error}
                </Text>
                {paymentError ? <JobPaymentErrorDisplay paymentError={paymentError} /> : null}
                <Grid container flexDirection="column" justifyContent="flex-end" flex={1}>
                    <Grid container gap={2} flexDirection="row" justifyContent="flex-end">
                        <SecondaryButton onClick={goBack} buttonStyle={{ width: 150 }}>
                            Back
                        </SecondaryButton>
                        <PrimaryButton
                            disabled={!selectedJob || loading}
                            onClick={submit}
                            buttonStyle={{ width: 150 }}
                            loading={loading}
                        >
                            Invite
                        </PrimaryButton>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
